import * as tslib_1 from "tslib";
import { observer } from 'mobx-react';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import ReadingPanePosition from 'owa-session-store/lib/store/schema/ReadingPanePosition';
import * as React from 'react';
var styles = require('./MessageAdListStubElement.scss');
var MessageAdListPreloadingStubElement = /** @class */ (function (_super) {
    tslib_1.__extends(MessageAdListPreloadingStubElement, _super);
    function MessageAdListPreloadingStubElement() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MessageAdListPreloadingStubElement.prototype.render = function () {
        var isReadingPanePositionOff = getUserConfiguration().UserOptions.GlobalReadingPanePositionReact ===
            ReadingPanePosition.Off;
        return (React.createElement("div", { className: isReadingPanePositionOff
                ? styles.messageAdStaticContainerReadingPaneOff
                : styles.messageAdStaticContainerReadingPaneOn }));
    };
    MessageAdListPreloadingStubElement = tslib_1.__decorate([
        observer
    ], MessageAdListPreloadingStubElement);
    return MessageAdListPreloadingStubElement;
}(React.Component));
export default MessageAdListPreloadingStubElement;
//# sourceMappingURL=MessageAdListPreloadingStubElement.js.map